import { render, staticRenderFns } from "./WysiwygField.vue?vue&type=template&id=0da6e082"
import script from "./WysiwygField.vue?vue&type=script&lang=js"
export * from "./WysiwygField.vue?vue&type=script&lang=js"
import style0 from "./WysiwygField.vue?vue&type=style&index=0&id=0da6e082&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports